import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'


const Aim = () => {
  return (
    <div>
      <Container>
        <h3 className='mt-5 mb-5'>Our Aim and Objectives</h3>
        <Row className='d-flex justify-content-center'>
          <Col md={8}>
          <h5 className='mt-5 mb-5'>The school aims at the integral personal formation of the young.To accomplish this, special
            efforts are made:-</h5>
            <ul style={{fontWeight:'700',marginBottom:'5rem'}}>
              <li>To inculcate in our students the perennial values of 21 century competency based skills enshrined
                in our rich cultural heritage.</li>
              <li>To develop the sense of pride for our country.</li>
              <li>To instill the feeling of universal brotherhood and reach out to the world at large.</li>
              <li>To improve a sense of social responsibility and self-confidence to lead and command.</li>
              <li>To flourish individual talents, fine traits of character like honesty, courage, interpersonal skills, 21st
                century competency based skills, high standard of personal and social conduct as well as
                appreciation of moral and spiritual values.</li>
            </ul>

          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Aim